<template>
  <slot />
</template>

<script>
import { loadScript } from './TransportChoices/helpers/loadScript'
const url = 'https://client.smartform.cz/v2/smartform.js'
const clientId = '0KAZfw6hq2'

const onSelect = (element, text) => {
  element.value = text

  element.dispatchEvent(new Event('input', { bubbles: true }))
  element.dispatchEvent(new Event('change', { bubbles: true }))
}

export default {
  name: 'SmartFormWidget',
  mounted() {
    loadScript(url, this.$options.name)
      .then(() => {
        window.smartform = window.smartform || {}

        window.smartform.beforeInit = function () {
          window.smartform.setClientId(clientId)
        }

        window.smartform.afterInit = function () {
          window.smartform.getInstanceIds().forEach(instanceId => {
            window.smartform.getInstance(instanceId).addressControl.setSelectionCallback(onSelect)
          })
        }

        if (typeof window.smartform.rebindAllForms !== 'undefined') {
          setTimeout(() => {
            window.smartform.rebindAllForms(function () {
              window.smartform.getInstanceIds().forEach(instanceId => {
                window.smartform
                  .getInstance(instanceId)
                  .addressControl.setSelectionCallback(onSelect)
              })
            })
          }, 0)
        }
      })
      .catch(console.log)
  },
  unmounted() {
    //removeScript(this.$options.name)
    if (window.smartform.unbindForm) {
      window.smartform
        .getInstanceIds()
        .forEach(instanceId => window.smartform.unbindForm(instanceId))
    }
  }
}
</script>
